import React from 'react'
import { CheckIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'

const TOTAL_STEPS = 4

export default function VerticalProgressSteps({ completedSteps = [] }) {
    const { t } = useTranslation()

    const allSteps = [
        { name: t('Projects.ProgressSteps.Prepare'), description: t('Projects.ProgressSteps.PrepareDescription') },
        { name: t('Projects.ProgressSteps.Question'), description: t('Projects.ProgressSteps.QuestionDescription') },
        { name: t('Projects.ProgressSteps.Analyze'), description: t('Projects.ProgressSteps.AnalyzeDescription') },
        { name: t('Projects.ProgressSteps.Report'), description: t('Projects.ProgressSteps.ReportDescription') },
    ]

    const currentStep = allSteps.findIndex((_, i) => !completedSteps.includes(i))

    const steps = allSteps.map((step, index) => ({
        ...step,
        status: completedSteps.includes(index) ? 'complete' : index === currentStep ? 'current' : 'upcoming',
    }))

    return (
        <nav aria-label="Progress">
            <ol className="overflow-hidden">
                {steps.map((step, stepIdx) => {
                    const isLast = stepIdx === steps.length - 1
                    return (
                        <li key={step.name} className={`${!isLast ? 'pb-6' : ''} relative`}>
                            {step.status === 'complete' ? (
                                <>
                                    {!isLast && (
                                        <div aria-hidden="true" className="absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-iavisus-100" />
                                    )}
                                    <div className="group relative flex items-start">
                                        <span className="flex h-9 items-center">
                                            <span className="relative z-10 flex w-8 h-8 items-center justify-center rounded-full bg-iavisus-100 group-hover:bg-iavisus-200">
                                                <CheckIcon aria-hidden="true" className="w-5 h-5 text-white" />
                                            </span>
                                        </span>
                                        <span className="ml-4 flex min-w-0 flex-col">
                                            <span className="text-sm font-medium text-gray-900">{step.name}</span>
                                            <span className="text-xs text-gray-600">{step.description}</span>
                                        </span>
                                    </div>
                                </>
                            ) : step.status === 'current' ? (
                                <>
                                    {!isLast && (
                                        <div aria-hidden="true" className="absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300" />
                                    )}
                                    <div aria-current="step" className="group relative flex items-start">
                                        <span aria-hidden="true" className="flex h-9 items-center">
                                            <span className="relative z-10 flex w-8 h-8 items-center justify-center rounded-full border-2 border-iavisus-100 bg-white">
                                                <span className="w-2.5 h-2.5 rounded-full bg-iavisus-100" />
                                            </span>
                                        </span>
                                        <span className="ml-4 flex min-w-0 flex-col">
                                            <span className="text-sm font-medium text-iavisus-100">{step.name}</span>
                                            <span className="text-xs text-gray-500">{step.description}</span>
                                        </span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {!isLast && (
                                        <div aria-hidden="true" className="absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300" />
                                    )}
                                    <div className="group relative flex items-start">
                                        <span aria-hidden="true" className="flex h-9 items-center">
                                            <span className="relative z-10 flex w-8 h-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400">
                                                <span className="w-2.5 h-2.5 rounded-full bg-transparent" />
                                            </span>
                                        </span>
                                        <span className="ml-4 flex min-w-0 flex-col">
                                            <span className="text-sm font-medium text-gray-500">{step.name}</span>
                                            <span className="text-xs text-gray-500">{step.description}</span>
                                        </span>
                                    </div>
                                </>
                            )}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}
